export * from './Either'; // exports 'Option'

export * from './Option'; // exports 'Either'
// eslint-disable-next-line @typescript-eslint/no-empty-function

export var noop = function noop() {};
export var nullish = function nullish() {
  return undefined;
};